import { render, staticRenderFns } from "./AccidentList.vue?vue&type=template&id=665c43e2"
import script from "./AccidentList.vue?vue&type=script&lang=js"
export * from "./AccidentList.vue?vue&type=script&lang=js"
import style0 from "./AccidentList.vue?vue&type=style&index=0&id=665c43e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports